import { getEnvironmentVariable } from "../../global/environmentVariables";

export function cardUtility(gameSystem) {
  if (getEnvironmentVariable("COMPANY_FLAG") === "shard-bugs") {
    return {
      sortOptions: {
        name: "Name",
        rarity: "Rarity",
        cardType: "Card Type",
        "faction.name": "Alliance"
      },
      dynamicSearch: {
        helperText:
          "Name, Set, Serial, Card Type, Trait, Resistance, Alliance or Card Text"
      },
      blankSearch: {
        fuzzy: true,
        includeVariants: false,
        showPublicOnly: true,
        highlightSearch: false,

        searchString: "",
        nameSearch: "",
        textSearch: "",
        serials: [],
        cardTypes: [],
        cardSubTypes: [],
        cardSubTypeChildren: [],
        rarities: [],

        factions: [],
        traits: [],
        resists: [],

        sortKey: "name",
        sortAscending: true
      },
      masterKeys: [
        { key: "cardSet", type: "string", keys: ["set"] },
        { key: "cardNumber", type: "number" },
        { key: "cardType", type: "string" },

        { key: "cardSubType", type: "string" },
        { key: "cardSubTypeChild", type: "string" },
        { key: "trait", type: "string" },
        { key: "resist", type: "string" },
        { key: "Dust Cost", type: "number" },
        { key: "Neutral Cost", type: "number" },
        { key: "Shard Cost", type: "number" },
        { key: "Devotion", type: "number" },

        { key: "name", type: "string", keys: ["cardName"] },
        { key: "keywords", type: "array" },
        { key: "textBox", type: "string", keys: ["cardText", "text"] },
        { key: "rarity", type: "string" },
        { key: "illustrator", type: "string", keys: ["artist"] },
        { key: "serial", type: "string" },
        {
          key: "factions",
          type: "array",
          keys: ["Lunar", "Meteor", "Solar", "Unaligned"]
        },
        { key: "version", type: "number" }
      ],
      cardSets: [
        { serial: "1ST", name: "The Bug-inning" },
        { serial: "2ND", name: "First Bounty" }
      ],
      cardTypes: [
        {
          name: "Cosmic Avatar"
        },
        {
          name: "Bug"
        },

        {
          name: "Action"
        },
        {
          name: "Quick Action"
        },
        {
          name: "Item"
        },
        {
          name: "Support"
        }
        // {
        //   name: "Token",
        // },
      ],
      cardSubTypes: {
        Bug: {
          cardSubTypeLabel: "Bug Type",
          cardSubTypes: ["Ant", "Bee", "Beetle", "Mantis", "Moth", "Worm"],
          cardSubTypeChildLabel: "Bug Class",
          cardSubTypeChildren: [
            "Cleric",
            "Commander",
            "Engineer",
            "Mage",
            "Warrior",
            "Ranger"
          ]
        },
        Item: {
          cardSubTypeLabel: "Item Type",
          cardSubTypes: ["Weapon"]
        },
        Support: {
          cardSubTypeLabel: "Support Type",
          cardSubTypes: ["Location", "Event"]
        }
      },
      traits: ["Flying", "Swimming", "Tunneling"],
      resists: ["Flying", "Swimming", "Tunneling"],
      rarities: [
        { code: "C", name: "Common" },
        { code: "UC", name: "Uncommon" },
        { code: "R", name: "Rare" },
        { code: "CR", name: "Cosmic Rare" },
        { code: "A", name: "Avatar" },
        { code: "T", name: "Token" }
      ],
      deckFormats: [
        {
          name: "Standard",
          deckSize: {
            min: 60
          },
          categories: {
            Side: {
              excludeFromTotal: true,
              size: {
                exact: true,
                min: 0,
                max: 10
              }
            }
          },
          rarities: {
            Common: { size: { max: 5 } },
            Uncommon: { size: { max: 4 } },
            Rare: { size: { max: 3 } },
            "Cosmic Rare": { size: { max: 2 } }
          },
          cards: {
            size: { max: 5 }
          }
        }
      ]
    };
  }

  return {
    sortOptions: {
      _score: "Relevance",
      name: "Name",
      cardType: "Card Type"
    },
    dynamicSearch: {
      helperText: "Name, Set, Serial, Card Type, Keyword, Color or Card Text"
    },
    blankSearch: {
      fuzzy: true,
      showPublicOnly: true,
      highlightSearch: false,

      searchString: "",
      nameSearch: "",
      textSearch: "",
      serials: [],
      cardTypes: [],
      rarities: [],

      factions: [],
      keywords: [],
      keywordsAll: false,

      sortKey: "_score",
      sortAscending: true
    },
    masterKeys: [
      { key: "cardSet", type: "string", keys: ["set"] },
      { key: "cardNumber", type: "number" },
      { key: "cardType", type: "string" },
      { key: "name", type: "string", keys: ["cardName"] },
      { key: "keywords", type: "array" },
      { key: "textBox", type: "string", keys: ["cardText", "text"] },
      { key: "rarity", type: "string" },
      { key: "illustrator", type: "string", keys: ["artist"] },
      { key: "serial", type: "string" },
      { key: "factions", type: "array" },
      { key: "version", type: "number" }
    ],
    cardSets: [
      { serial: "SET01", name: "Set 01" },
      { serial: "SET01-P", name: "Set 01 Promo Pack" }
    ],
    cardTypes: ["Attack", "Block"],
    keywords: [
      "Beats Paper",
      "Beats Scissors",
      "Beats Rock",
      "Beats Lizard",
      "Beats Spock"
    ],
    rarities: [
      { code: "C", name: "Common" },
      { code: "UC", name: "Uncommon" },
      { code: "R", name: "Rare" }
    ],
    deckFormats: [
      {
        name: "Standard",
        deckSize: {
          min: 20
        },
        categories: {
          Side: {
            excludeFromTotal: true,
            size: {
              exact: true,
              min: 0,
              max: 10
            }
          }
        },
        cards: {
          size: { max: 5 }
        }
      },
      {
        name: "Common Ground",
        deckSize: {
          min: 51
        },
        categories: {
          Character: {
            size: {
              min: 1
            }
          },
          Action: {
            rarities: ["Common", "Uncommon"]
          },
          Asset: {
            rarities: ["Common", "Uncommon"]
          },
          Attack: {
            rarities: ["Common", "Uncommon"]
          },
          Foundation: {
            rarities: ["Common", "Uncommon"]
          },

          Side: {
            excludeFromTotal: true,
            size: {
              exact: true,
              min: 0,
              max: 10
            }
          }
        },
        cards: {
          size: { max: 4 }
        }
      }
    ]
  };
}
